import React from 'react';
import PropTypes from 'prop-types';
import Cookies from 'js-cookie';
import { Spinner } from '../../../ui/src/component/spinner';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import {
  getCalendarLocations,
  fetchCalendarStaticTextAdd,
  getUser,
} from '../../actions.js';
import {
  warningAlert,
  successAlert,
  setAlert,
} from '../../../ui/src/actions.js';
import { CsmArticleContent } from '../../../ui/src/component/csmArticle';
import moment from 'moment';
import { Helmet } from 'react-helmet';
import { Popup } from '../../component/popup/';
import DatePicker from 'react-datepicker';
import Api from '../../../ui/src/api.js';
import { getProp } from '../../../ui/src/utilities';

class CalendarForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      authenticated: false,
      adminAuth: false,
      loaded: false,
      authPassword: '',
      locationsPopupOpened: false,
      dates: [this.createNewDate()],
      form: {
        title: '',
        description: '',
        name: '',
        surname: '',
        email: '',
        phone: '',
        url: '',
        locationId: '',
        password: '',
        password_b: '',
      },
    };

    this.addDate = this.addDate.bind(this);
  }

  createNewDate() {
    let date = moment(getProp(this.props, 'location.query.date'));
    if (!date.isValid()) {
      date = moment();
    }
    return {
      date,
      timeFrom: '08:00',
      timeTo: '10:00',
    };
  }

  static init(dispatch, params) {
    return Promise.all([
      dispatch(getCalendarLocations()),
      dispatch(fetchCalendarStaticTextAdd()),
    ]);
  }

  componentDidMount() {
    if (this.props.params.id) {
      const token = Cookies.get('token');
      let authenticated = false;
      Promise.all([
        token
          ? this.props.dispatch(getUser()).then(() => {
            if (
              getProp(this.props, 'user.scopes', []).filter(
                scope => scope === 'admin',
              ).length === 1
            ) {
              authenticated = true;
            }
          })
          : null,
      ]).then(() => {
        Api.get(`/calendar/events/${this.props.params.id}`)
          .then(response => {
            this.setState({
              authenticated: authenticated,
              loaded: true,
              dates: getProp(response, 'dates', []).map(date => {
                const from = moment(date.from);
                const to = moment(date.to);
                return {
                  date: from,
                  timeFrom: from.format('HH:mm'),
                  timeTo: to.format('HH:mm'),
                };
              }),
              form: {
                title: getProp(response, 'title'),
                description: getProp(response, 'description'),
                name: getProp(response, 'submitter.name'),
                surname: getProp(response, 'submitter.surname'),
                email: getProp(response, 'submitter.email'),
                phone: getProp(response, 'submitter.phone'),
                url: getProp(response, 'url'),
                locationId: getProp(response, 'location'),
              },
            });
          })
          .catch(error => {
            this.props.dispatch(push('/'));
          });
      });
    } else {
      const token = Cookies.get('token');
      let adminAuth = false;
      Promise.all([
        token
          ? this.props.dispatch(getUser()).then(() => {
            if (
              getProp(this.props, 'user.scopes', []).filter(
                scope => scope === 'admin',
              ).length === 1
            ) {
              adminAuth = true;
            }
          })
          : null,
      ]).then(() => {
        this.setState({
          authenticated: true,
          adminAuth: adminAuth,
          loaded: true,
        });
      });
    }

    CalendarForm.init(this.props.dispatch, this.props.params).catch(() => { });
  }

  onClickLocationPopupItem(item) {
    if (this.props.params.id) {
      this.setState({
        form: Object.assign({}, this.state.form, {
          locationId: item._id,
        }),
      });
    } else {
      this.props.dispatch(push(`/calendar/add/${item._id}`));
    }
    this.setState({ locationsPopupOpened: false });
  }

  onSubmit(e) {
    e.preventDefault();
    this.submit();
  }

  onSubmitAuth(e) {
    e.preventDefault();
    this.submitAuth();
  }

  addDate() {
    let dates = this.state.dates;
    dates.push(this.createNewDate());
    this.setState({ dates: dates });
  }

  removeDate(idx) {
    let dates = [
      ...this.state.dates.slice(0, idx),
      ...this.state.dates.slice(idx + 1),
    ];
    this.setState({ dates });
  }

  onChangeInput(ev) {
    this.setState({
      form: Object.assign({}, this.state.form, {
        [ev.target.name]: ev.target.value,
      }),
    });
  }

  onAuthChangeInput(ev) {
    this.setState({
      authPassword: ev.target.value,
    });
  }

  onChangeDatesInput(datesIdx, ev) {
    let dates = this.state.dates;
    dates[datesIdx] = Object.assign({}, dates[datesIdx], {
      [ev.target.name]: ev.target.value,
    });
    this.setState({ dates });
  }

  onChangeDatesDate(datesIdx, date) {
    let dates = this.state.dates;
    dates[datesIdx] = Object.assign({}, dates[datesIdx], {
      date: date,
    });
    this.setState({ dates });
  }

  submitAuth() {
    Api.post(`/calendar/events/${this.props.params.id}/access`, {
      password: this.state.authPassword,
    })
      .then(res => {
        if (res.status === 'OK') {
          this.setState({
            authenticated: true,
          });
        }
      })
      .catch(e => {
        this.props.dispatch(warningAlert('Zadané heslo je neplatné'));
        return;
      });
  }

  submit() {
    // vyskladame objekt
    let data = {
      title: this.state.form.title.trim(),
      description: this.state.form.description.trim(),
      url: this.state.form.url,
      submitter: {
        name: this.state.form.name.trim(),
        surname: this.state.form.surname.trim(),
        email: this.state.form.email.trim(),
        phone: this.state.form.phone.split(' ').join(''),
      },
      dates: this.state.dates.map(date => {
        return {
          date: date.date,
          timeFrom: this.parseTime(date.timeFrom.trim()),
          timeTo: this.parseTime(date.timeTo.trim()),
        };
      }),
    };
    if (!this.props.params.id && !this.state.adminAuth) {
      data.password = this.state.form.password.trim();
      data.password_b = this.state.form.password_b.trim();
    }

    // zvalidujeme
    const errors = this.validate(data);
    if (errors.length > 0) {
      this.props.dispatch(
        warningAlert('Nesprávne vyplnený formulár', {
          text: errors.join('\n'),
        }),
      );
      return;
    }

    // postprocessing
    data = Object.assign({}, data, {
      dates: data.dates.map(date => {
        return {
          from: moment(date.date)
            .startOf('day')
            .add(date.timeFrom, 'seconds'),
          to: moment(date.date)
            .startOf('day')
            .add(date.timeTo, 'seconds'),
        };
      }),
    });

    // posleme
    let promise = null;
    // zbytocne nebudeme posielat kontrolu hesla
    delete data.password_b;
    if (this.props.params.id) {
      data['location'] = this.state.form.locationId;
      data['password'] = this.state.authPassword;
      promise = Api.put(`/calendar/events/${this.props.params.id}`, data);
    } else {
      promise = Api.post(`/calendar/${this.getCurrentLocation()._id}`, data);
    }
    promise
      .then(response => {
        this.props.dispatch(
          successAlert('Udalosť bola uložená!', {
            onConfirm: () => {
              this.props.dispatch(setAlert(null));
              this.props.dispatch(
                push(
                  `/calendar/${
                  this.getCurrentLocation()._id
                  }/${data.dates[0].from.format('YYYY-MM-DD')}`,
                ),
              );
            },
          }),
        );
      })
      .catch(error => {
        if (error.response.status === 400) {
          const paths = getProp(error, 'details.payload.paths', []);
          if (paths.includes('submitter.email')) {
            this.props.dispatch(
              warningAlert('Nesprávny formát emailovej adresy'),
            );
          } else {
            this.props.dispatch(warningAlert('Chybne vyplnený formulár'));
          }
        } else {
          this.props.dispatch(warningAlert('Udalosť nie je možné uložiť'));
        }
        console.error(error);
      });
  }

  /**
   * Returns number of seconds after parsing time in format of "08:00".
   * @param {string} timeStr
   * @return {number|null} Number of seconds
   */
  parseTime(timeStr) {
    let matches = /^(\d?\d):(\d\d)$/.exec(timeStr);
    if (!matches) {
      return null;
    }
    return parseInt(matches[1], 10) * 3600 + parseInt(matches[2], 10) * 60;
  }

  validate(data) {
    let error = [];
    if (!data.title) {
      error.push('Vyplňte názov udalosti');
    }
    if (!data.title) {
      error.push('Vyplňte názov udalosti');
    }
    return [
      ...error,
      ...this.validateSubmitter(data.submitter),
      ...this.validateDates(data.dates),
      ...(!this.props.params.id && !this.state.adminAuth
        ? this.validatePassword(data.password.trim(), data.password_b.trim())
        : []),
    ];
  }

  validatePassword(password, passwordB) {
    let error = [];
    if (password === '' || passwordB === '') {
      error.push('Zadajte heslo pre úpravu a zmazanie udalosti.');
    } else if (password !== passwordB) {
      error.push('Zadané heslá sa nezhodujú.');
    }
    return error;
  }

  validateSubmitter(submitter) {
    let error = [];
    if (!submitter.name) {
      error.push('Vyplňte meno');
    }
    if (!submitter.surname) {
      error.push('Vyplňte priezvisko');
    }
    if (!submitter.email) {
      error.push('Vyplňte e-mail');
    }
    if (!submitter.phone) {
      error.push('Vyplňte telefón');
    }
    return error;
  }

  validateDates(dates) {
    let error = [];
    let pos = 1;
    for (let date of dates) {
      if (!date.date) {
        error.push(`Nesprávny dátum v ${pos}. termíne`);
      }
      if (date.timeFrom === null) {
        error.push(
          `Nesprávny začiatočný čas v ${pos}. termíne. Zadajte vo formáte 00:00`,
        );
      }
      if (date.timeTo === null) {
        error.push(
          `Nesprávny konečný čas v ${pos}. termíne. Zadajte vo formáte 00:00`,
        );
      }
      if (
        date.timeFrom !== null &&
        date.timeTo !== null &&
        date.timeFrom >= date.timeTo
      ) {
        error.push(
          `Nesprávne časy v ${pos}. termíne. Čas "od" by mal byť pred časom "do".`,
        );
      }
      pos++;
    }
    return error;
  }

  getCurrentLocation() {
    let currentLocationId;
    if (this.props.params.id) {
      currentLocationId = this.state.form.locationId;
    } else {
      currentLocationId = this.props.params.location;
    }
    let currentLocation;
    if (currentLocationId) {
      for (let l of this.props.locations) {
        if (l._id === currentLocationId) {
          currentLocation = l;
          break;
        }
      }
    }
    if (!currentLocation) {
      currentLocation = this.props.locations[0];
    }
    return currentLocation;
  }

  render() {
    if (
      (!this.props.locations.length || !this.props.calendarStaticTextAdd) &&
      !this.state.loaded
    ) {
      return <Spinner show={true} />;
    }
    if (!this.state.authenticated && this.state.loaded) {
      return (
        <div className="article-form">
          <Helmet>
            <title>Kalendár - Pridaj udalosť</title>
          </Helmet>
          <div className="container">
            <div className="section">
              <div className="row">
                <div className="col-sm-12 col-md-8">
                  <form
                    className="form-horizontal"
                    onSubmit={this.onSubmitAuth.bind(this)}
                  >
                    <div className="form-group">
                      <label className="col-sm-4 col-md-3 control-label">
                        Heslo pre úpravu *
                      </label>
                      <div className="col-sm-8 col-md-8">
                        <input
                          onChange={this.onAuthChangeInput.bind(this)}
                          name="password"
                          type="password"
                          className="form-control"
                        />
                        <button
                          type="submit"
                          style={{
                            position: 'absolute',
                            top: 0,
                            right: 0,
                            borderRadius: '0px 4px 4px 0px',
                          }}
                          className="btn btn-primary"
                        >
                          Overiť heslo
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    // nastavime objekt aktualne zvolenej lokality
    let currentLocation = this.getCurrentLocation();

    return (
      <div className="article-form">
        <Helmet>
          <title>Kalendár - Pridaj udalosť</title>
        </Helmet>

        <div className="bg-alt-light article-header">
          <div className="container">
            <div className="article-header-title">
              <h1>
                {this.props.params.id
                  ? 'Upraviť udalosť v'
                  : 'Pridaj udalosť v'}
                &nbsp;<span className="text-primary">
                  {currentLocation.name}
                </span>{' '}
                <span style={{ position: 'relative', display: 'inline-block' }}>
                  <button
                    className="btn btn-primary btn-xs text-uppercase popup-trigger"
                    onClick={() =>
                      this.setState({
                        locationsPopupOpened: !this.state.locationsPopupOpened,
                      })
                    }
                  >
                    zmeniť
                  </button>
                  <span className="popup-container">
                    <Popup
                      eventTypes="click"
                      opened={this.state.locationsPopupOpened}
                      items={getProp(this.props, 'locations', []).map(item => (
                        <a
                          onClick={e => {
                            e.preventDefault();
                            this.onClickLocationPopupItem(item)
                          }}
                          href=""
                        >
                          {item.name}
                        </a>
                      ))}
                      handleClickOutside={() =>
                        this.setState({ locationsPopupOpened: false })
                      }
                      outsideClickIgnoreClass={'popup-trigger'}
                    />
                  </span>
                </span>
              </h1>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="section">
            <div className="row">
              <div className="col-sm-12 col-md-8">
                <form
                  className="form-horizontal"
                  onSubmit={this.onSubmit.bind(this)}
                >
                  <div className="form-group">
                    <label className="col-sm-4 col-md-3 control-label">
                      Názov udalosti*
                    </label>
                    <div className="col-sm-8 col-md-8">
                      <input
                        onChange={this.onChangeInput.bind(this)}
                        name="title"
                        value={this.state.form.title}
                        type="text"
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="col-sm-4 col-md-3 control-label">
                      Popis udalosti
                    </label>
                    <div className="col-sm-8 col-md-8">
                      <textarea
                        onChange={this.onChangeInput.bind(this)}
                        name="description"
                        value={this.state.form.description}
                        className="form-control"
                        rows="10"
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="col-sm-4 col-md-3 control-label">
                      Web
                    </label>
                    <div className="col-sm-8 col-md-8">
                      <input
                        onChange={this.onChangeInput.bind(this)}
                        name="url"
                        value={this.state.form.url}
                        type="text"
                        className="form-control"
                        placeholder="http://... (nepovinné)"
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="col-sm-4 col-md-3 control-label">
                      Termín*
                    </label>
                    <div className="col-sm-8 col-md-8">
                      {this.state.dates.map((item, idx) => {
                        return (
                          <div
                            key={idx}
                            className="form-inline"
                            style={{ marginBottom: '0.5em' }}
                          >
                            <DatePicker
                              className="form-control"
                              dateFormat="DD.MM.YYYY"
                              selected={item.date}
                              onChange={this.onChangeDatesDate.bind(this, idx)}
                              placeholderText="dd.mm.yyyy"
                            />
                            &nbsp;&nbsp;&nbsp;
                            <div className="input-group time-picker">
                              <div className="input-group-addon">Čas</div>
                              <input
                                onChange={this.onChangeDatesInput.bind(
                                  this,
                                  idx,
                                )}
                                value={item.timeFrom}
                                name="timeFrom"
                                type="text"
                                className="form-control"
                                placeholder="08:00"
                              />
                              <div className="input-group-addon"> - </div>
                              <input
                                onChange={this.onChangeDatesInput.bind(
                                  this,
                                  idx,
                                )}
                                value={item.timeTo}
                                name="timeTo"
                                type="text"
                                className="form-control"
                                placeholder="08:00"
                              />
                            </div>
                            &nbsp;&nbsp;&nbsp;
                            {this.state.dates.length > 1 && (
                              <span>
                                <button
                                  type="button"
                                  onClick={this.removeDate.bind(this, idx)}
                                  className="btn btn-primary text-uppercase btn-xs"
                                >
                                  odstrániť
                                </button>
                                &nbsp;
                              </span>
                            )}
                            {idx + 1 === this.state.dates.length && (
                              <div className="text-center">
                                <br />
                                <button
                                  type="button"
                                  onClick={this.addDate}
                                  className="btn btn-primary text-uppercase btn-xs"
                                >
                                  pridať termín
                                </button>
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="col-sm-4 col-md-3 control-label">
                      Meno a priezvisko*
                    </label>
                    <div className="col-sm-4 col-md-4">
                      <input
                        onChange={this.onChangeInput.bind(this)}
                        name="name"
                        value={this.state.form.name}
                        type="text"
                        className="form-control"
                        placeholder="Meno"
                      />
                    </div>
                    <div className="col-sm-4 col-md-4">
                      <input
                        onChange={this.onChangeInput.bind(this)}
                        name="surname"
                        value={this.state.form.surname}
                        type="text"
                        className="form-control"
                        placeholder="Priezvisko"
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="col-sm-4 col-md-3 control-label">
                      E-mail*
                    </label>
                    <div className="col-sm-8 col-md-8">
                      <input
                        onChange={this.onChangeInput.bind(this)}
                        name="email"
                        value={this.state.form.email}
                        type="text"
                        className="form-control"
                        placeholder="E-mailová adresa"
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="col-sm-4 col-md-3 control-label">
                      Telefón*
                    </label>
                    <div className="col-sm-8 col-md-8">
                      <input
                        onChange={this.onChangeInput.bind(this)}
                        name="phone"
                        value={this.state.form.phone}
                        type="text"
                        className="form-control"
                        placeholder="+421 901 234 567"
                      />
                    </div>
                  </div>
                  {!this.props.params.id &&
                    !this.state.adminAuth && (
                      <div className="form-group">
                        <label className="col-sm-4 col-md-3 control-label">
                          Heslo pre úpravu*
                        </label>
                        <div className="col-sm-4 col-md-4">
                          <input
                            onChange={this.onChangeInput.bind(this)}
                            name="password"
                            value={this.state.form.password}
                            type="password"
                            className="form-control"
                            placeholder="Heslo"
                          />
                        </div>
                        <div className="col-sm-4 col-md-4">
                          <input
                            onChange={this.onChangeInput.bind(this)}
                            name="password_b"
                            value={this.state.form.password_b}
                            type="password"
                            className="form-control"
                            placeholder="Heslo znova"
                          />
                        </div>
                      </div>
                    )}
                  <div
                    className="text-center col-md-8 col-md-offset-3"
                    style={{ marginBottom: '30px' }}
                  >
                    <br />
                    <em className="text-muted">Údaje označené * sú povinné</em>
                    <br />
                    <br />
                    <button type="submit" className="btn btn-primary">
                      Uložiť udalosť
                    </button>
                  </div>
                </form>
              </div>
              <div className="col-sm-12 col-md-4">
                {this.props.calendarStaticTextAdd && (
                  <div>
                    {this.props.calendarStaticTextAdd.name && (
                      <h2 style={{ marginTop: 0 }}>
                        {this.props.calendarStaticTextAdd.name}
                      </h2>
                    )}
                    <CsmArticleContent
                      content={this.props.calendarStaticTextAdd}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

CalendarForm.propTypes = {
  calendarStaticTextAdd: PropTypes.object,
  dispatch: PropTypes.func.isRequired,
  locations: PropTypes.array.isRequired,
  params: PropTypes.object.isRequired,
  user: PropTypes.object,
};

CalendarForm.fetchData = ({ store, renderProps: { params } }) => {
  return CalendarForm.init(store.dispatch, params);
};

export default connect(state => {
  return {
    locations: state.calendar.locations,
    calendarStaticTextAdd: state.calendarStaticTextAdd.data.content,
    user: state.loggedUser.user,
  };
})(CalendarForm);



// WEBPACK FOOTER //
// ./src/app/container/calendar/calendar-form.js